import React from 'react';
import Main from './components/Main';

import './assets/img/favicon.ico';

import '../semantic/dist/semantic.min.css';
import './app.scss';

export default function App() {
  return <Main />;
}



// WEBPACK FOOTER //
// ./src/app.js